import React from 'react';

function PrivacyPolicy() {
  return (
    <div className="page-container">
      <section className="content-section privacy-content">
        <h1 className="page-title">Privacy Policy</h1>

        <div className="card">
          <h2>Who we are</h2>
          <p>Our website address is: https://cmlawler.com.</p>

          <h2>Contact Form Data</h2>
          <p>
            When visitors submit the contact form on our site, we collect the data provided in the
            form fields (name, email, subject, and message). This information is used solely to
            respond to your inquiry. Form submissions are processed through Formspree, a third-party
            form handling service. Please refer to Formspree's privacy policy for details on how they
            handle your data.
          </p>

          <h2>Cookies</h2>
          <p>
            This site does not use cookies for tracking or advertising purposes. As a static website,
            no login or session cookies are set.
          </p>

          <h2>Embedded content from other websites</h2>
          <p>
            Articles on this site may include embedded content (e.g. videos, images, articles, etc.).
            Embedded content from other websites behaves in the exact same way as if the visitor has
            visited the other website. These websites may collect data about you, use cookies, embed
            additional third-party tracking, and monitor your interaction with that embedded content.
          </p>

          <h2>Your rights over your data</h2>
          <p>
            If you have submitted a contact form, you can request that we erase any personal data we
            hold about you. This does not include any data we are obliged to keep for administrative,
            legal, or security purposes.
          </p>

          <h2>Contact</h2>
          <p>
            For any privacy-related questions, please contact us at{' '}
            <a href="tel:+14154088798">415.408.8798</a>.
          </p>
        </div>
      </section>
    </div>
  );
}

export default PrivacyPolicy;
